module.exports = __webpack_public_path__ + "img/ui_base_edit.89401492.png";